<template>
    <el-select v-model="model" placeholder="请选择" 
        multiple filterable size="small" remote
        :disabled="disabled"
        :remote-method="filterData"
        class="select"
        @focus="filterData">
        <el-option
        v-for="item in userOptions"
        :key="item.userId"
        :label="item.fullname"
        :value="item.userId">
            <span>{{ item.fullname }} <span style="color: #8492a6; font-size: 13px">（{{ item.companyId }}）</span></span>
        </el-option>
    </el-select>
</template>
<script>
import { mapState,mapActions } from "vuex";
export default {
    name: 'users',
    data() {
        return {
            model: '',
            userOptions: []
        }
    },
    props: {
        value: {
            type: Array,
            default: []
        },
        disabled: {
            type: [Number, Boolean],
            default: false
        }
    },
    watch: {
        value(val){
            this.model = val;
        },
        model: {
            handler(val) {
                this.$emit("input", val);
            }
        }
    },
    computed: {
        ...mapState('pushPushPlanOperate', ['users'])
    },
    methods: {
        ...mapActions('pushPushPlanOperate', ['getAllUsers']),
        filterData(kwd) {
            if(typeof kwd === 'string' && kwd) {
                this.userOptions = this.users.filter(item => {
                    let names = [item.fullname, item.firstnamePinYin, item.fullnameFirstLetter, item.username].join('【】').toLowerCase();
                    return names.toLowerCase().indexOf(kwd) > -1;
                })
            }else {
                this.userOptions = _.cloneDeep(this.users);
            }
        },
    },
    created() {
        this.getAllUsers().then(_ => {
            this.filterData()
        });
    }
}
</script>
<style lang="scss" scoped>
    .select{
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// website/subComponents/push/SelectUsers.vue